module.exports = __webpack_public_path__ + "img/blocktrac-tutorial.4ba4563b.png";